import { User } from '../../models/user.model';
import * as AuthActions from './auth.actions';

export interface AuthState {
  isLoggedIn: boolean | null;
  user: User | null;
  loginError: string | null;
}

export const authFeatureKey = 'auth';

export { AuthActions };
